import * as TAGS_ACTIONS from '../../../common/tags/tagConstants';
import { produce } from 'immer';
import {
    TagAction,
    TagCreateAction,
    TagDeleteAction,
    TagMap,
    TagsLoadAction,
    TagUpdateAction,
} from '../../../common/tags/tagTypes';
import * as TAGS_ACTION_TYPE from '../../../common/tags/tagConstants';

const initialState: TagMap = {};

const tagsReducer = (state = initialState, action: TagAction): TagMap => {
    switch (action.type) {
        case TAGS_ACTIONS.TAGS_LOAD:
            return produce(state, (draft) => {
                (action as TagsLoadAction).tags.forEach((tag) => {
                    draft[tag.id as string] = tag;
                });
            });

        case TAGS_ACTION_TYPE.TAG_CREATE:
            return produce(state, (draft) => {
                const { tag } = action as TagCreateAction;

                draft[tag.id as string] = tag;
            });

        case TAGS_ACTIONS.TAG_UPDATE:
            return produce(state, (draft) => {
                const { tagId, changes } = action as TagUpdateAction;
                const existingTag = draft[tagId];
                if (!existingTag) return;

                draft[tagId] = { ...existingTag, ...changes };
            });

        case TAGS_ACTIONS.TAG_DELETE:
            return produce(state, (draft) => {
                const tagId = (action as TagDeleteAction).tagId;
                delete draft[tagId];
            });

        default:
            return state;
    }
};

export default tagsReducer;
